"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMemberEligibleForBTM = exports.isDOBEligibleForBTM = exports.isMemberEligibleForHealth = exports.isDOBEligibleForHealth = exports.isMemberEligibleForMedicare = exports.isDOBEligibleForMedicare = void 0;
const utils_1 = require("@hc-frontend/utils");
/**
 * Check if the date of birth is eligible for Medicare
 *
 * @public
 * @param {DOB} dateOfBirth - The date of birth to check
 *
 * @returns {boolean} If the date of birth is less that 64.5 years (-65 years plus 6 month gap) then return true otherwise return false
 *
 * @example
 * ```ts
 * const result = isDOBEligibleForMedicare(new Date(2000, 1 , 1));
 * console.log(result);
 * /// -> true
 * ```
 */
function isDOBEligibleForMedicare(dateOfBirth) {
    const dobTime = dateOfBirth.getTime();
    const dateToCompare = (0, utils_1.alterDate)({ years: -65, months: 6 }).getTime();
    return dateToCompare >= dobTime;
}
exports.isDOBEligibleForMedicare = isDOBEligibleForMedicare;
/**
 * Check if the applicant is eligible for Medicare
 *
 * @public
 * @param {T extends {dob: DOB}} applicant - The applicant to check
 *
 * @returns {boolean} Returns true if applicant can apply for Medicare otherwise returns false
 *
 * @example
 * ```ts
 * const result = isMemberEligibleForMedicare(applicant);
 * console.log(result);
 * /// -> false
 * ```
 */
function isMemberEligibleForMedicare(member) {
    return isDOBEligibleForMedicare(member.dob);
}
exports.isMemberEligibleForMedicare = isMemberEligibleForMedicare;
/**
 * Check if the date of birth is eligible for health
 *
 * @public
 * @param {DOB} dateOfBirth - The date of birth to check
 *
 * @returns {boolean} If the date of birth is under 64.5 years (-65 years plus 6 month gap) then return true otherwise return false
 *
 * @example
 * ```ts
 * const result = isDOBEligibleForHealth(new Date(2000, 1 , 1));
 * console.log(result);
 * /// -> false
 * ```
 */
function isDOBEligibleForHealth(dateOfBirth) {
    return !isDOBEligibleForMedicare(dateOfBirth);
}
exports.isDOBEligibleForHealth = isDOBEligibleForHealth;
/**
 * Check if the member is eligible for health
 *
 * @public
 * @param {T extends {dob: DOB}} member - The member to check
 *
 * @returns {boolean} Returns true if member can apply for health otherwise returns false
 *
 * @example
 * ```ts
 * const result = isMemberEligibleForHealth(member);
 * console.log(result);
 * /// -> false
 * ```
 */
function isMemberEligibleForHealth(member) {
    return isDOBEligibleForHealth(member.dob);
}
exports.isMemberEligibleForHealth = isMemberEligibleForHealth;
/**
 * Check if the date of birth is eligible for BTM
 *
 * @public
 * @param {DOB} dateOfBirth - The date of birth to check
 *
 * @returns {boolean} If the date of birth is under 64.5 years (-65 years plus 6 month gap) then return true otherwise return false
 *
 * @example
 * ```ts
 * const result = isDOBEligibleForHealth(new Date(2000, 1 , 1));
 * console.log(result);
 * /// -> false
 * ```
 */
function isDOBEligibleForBTM(dateOfBirth) {
    const dobTime = dateOfBirth.getTime();
    const back64Years11Months = (0, utils_1.alterDate)({
        years: -65,
        months: 1,
        days: 2,
    }).getTime();
    const back60Years = (0, utils_1.alterDate)({ years: -60, days: 1 }).getTime();
    return dobTime >= back64Years11Months && dobTime <= back60Years;
}
exports.isDOBEligibleForBTM = isDOBEligibleForBTM;
/**
 * Check if the member is eligible for BTM
 *
 * @public
 * @param {T extends {dob: DOB}} member - The member to check
 *
 * @returns {boolean} Returns true if member can apply for health otherwise returns false
 *
 * @example
 * ```ts
 * const result = isMemberEligibleForBTM(member);
 * console.log(result);
 * /// -> false
 * ```
 */
function isMemberEligibleForBTM(member) {
    return isDOBEligibleForBTM(member.dob);
}
exports.isMemberEligibleForBTM = isMemberEligibleForBTM;
//# sourceMappingURL=is-eligible-for.js.map